import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useMemo } from "react";

export function useScreenSize() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });

  const isTablet =
    useMediaQuery(theme.breakpoints.down("lg"), { noSsr: true }) && !isMobile;

  return useMemo(() => ({ isDesktop, isMobile, isTablet }), [
    isDesktop,
    isMobile,
    isTablet,
  ]);
}
